<ng-container *ngIf="fullName === ''; else printLetters">
    <ng-container *ngIf="image === ''; else printImage">
        <img class="{{classImage}}" src="./assets/images/logo/sanetPN.svg" alt="Perfil"/>
    </ng-container>
    <ng-template #printImage>
        <img class="{{classImage}}" src="{{imageComplete}}" alt="Perfil"/>
    </ng-template>
</ng-container>
<ng-template #printLetters>
    <div class="{{classContainer}}">
        <h3 class="h3 user-avatar-txt"><strong>{{getLogoLetters(fullName)}}</strong></h3>
    </div>
</ng-template>
